import { z } from 'zod';
import type { EventSubscriptionToken } from '@sleed/bizcommerce-api';

/**
 * Event subscription edit form. The subscription type, payload and customer id are server-set
 * (read-only in the legacy form); only the notification email and the disabled flag are editable.
 * Those read-only fields are carried through so an update never wipes them.
 */
export const eventSubscriptionSchema = z.object({
	id: z.number().optional(),
	eml: z.string().trim().min(1, 'validation.required').max(50, 'validation.tooLong').email('validation.email'),
	disabled: z.boolean(),
	type: z.string().nullable(),
	payload: z.string().nullable(),
	cid: z.number().nullable()
});

export type EventSubscriptionFormValues = z.infer<typeof eventSubscriptionSchema>;

export function tokenToForm(token: EventSubscriptionToken): EventSubscriptionFormValues {
	return {
		id: token.id,
		eml: token.eml ?? '',
		disabled: token.Disabled ?? false,
		type: token.EventSubscriptionsType ?? null,
		payload: token.Payload ?? null,
		cid: token.cid ?? null
	};
}

export function formToToken(form: EventSubscriptionFormValues): EventSubscriptionToken {
	return {
		id: form.id,
		eml: form.eml.trim(),
		Disabled: form.disabled,
		EventSubscriptionsType: form.type,
		Payload: form.payload,
		cid: form.cid
	};
}
